<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Ec7NqI/tc-custom/9781459251816.jpg?1720015951328" alt="This image is the cover for the book Giordanni's Proposal"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Giordanni's Proposal
      </h1>
      <p class="bookDescription body article font2">
        <b>From a <i>USA Today</i>–bestselling author, a billionaire proposes marriage to an innocent woman to protect his family and falls in love with his fiancée.</b><br/><br/>A marriage proposal—Italian-style!<br/><br/>Beth was left breathless when gorgeous Italian tycoon Dex Giordanni proposed marriage—within days of meeting her! But then she overheard a conversation that chilled her: Dex wanted to wed her to settle a family score.<br/><br/>Beth prepared herself to end their engagement—how could she have been so naive as to think Dex was really interested in a virgin like her? But Dex didn’t take no for an answer. If a diamond ring couldn’t seduce her to the altar, then he would!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jacqueline Baird
      </h2>
      
      <p class="authorDescription body article">When Jacqueline Baird is not busy writing she likes to spend her time travelling, reading and playing cards. She enjoys swimming in the sea when the weather allows. With a more sedentary lifestyle, she does visit a gym three times a week and has made the surprising discovery that she gets some of her best ideas while doing mind-numbingly boring exercises on the weight machines and airwalker. Jacqueline lives with her husband Jim in Northumberland.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?da97b91a